import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    let stored = null;
    try { stored = localStorage.getItem("kd-preview-lang") || localStorage.getItem("kd_lang"); } catch { /* Use Marathi when storage is unavailable. */ }
    return stored === "en" || stored === "mr" ? stored : "mr";
  });

  useEffect(() => {
    try { localStorage.setItem("kd_lang", lang); localStorage.setItem("kd-preview-lang", lang); } catch { /* Language still works without storage. */ }
    document.documentElement.lang = lang === "mr" ? "mr" : "en";
    document.body.setAttribute("data-lang", lang);
  }, [lang]);

  const t = (key) => {
    const dict = translations[lang] || translations.mr;
    return key.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : null), dict) ?? key;
  };

  const toggleLang = () => setLang((p) => (p === "mr" ? "en" : "mr"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
